<template  >
    <div class="cubeSpace d-flex flex-wrap justify-content-center align-items-center py-4 px-lg-3 px-4 px-lg-0 py-5 py-lg-0">
        <div class="col-12 d-flex h-100 justify-content-center align-items-center align-content-center overflow-hidden position-relative">  
            <div class="col-12 d-flex justify-content-center text-center align-items-center flex-wrap px-lg-4">
                <span class="font- fuente-posm label-1 d-flex flex-wrap">Incrementa la Lealtad y Genera Relaciones.</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'page8',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a1: require('@/assets/images/a1.png'),
        }
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        }
    },
}
</script>
<style lang="css" scoped>
    .cubeSpace {
        overflow: hidden;
        height: auto;
        width: 100vw;
        height: 100vh;
    }
    
    
    .label-1 {
        color: var(--color-5);
        font-size: 80px;
        line-height: 1.1;
        max-width: 850px;
        word-wrap: break-word;
    }
    @media (max-width: 992px) and (min-width: 768px) {
        .label-1
        {
            font-size: 70px;
        }
    }
    @media (max-width: 767px) and (min-width: 0) {
        .label-1
        {
            font-size: 35px;
        }
    }
</style>